import React from 'react';
import Button from 'fuse-ui/components/Button';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from 'fuse-ui/components/Typography';
import { formatDate } from '../../utils/common-utils';

const styles = theme => ( {
    note: {
        whiteSpace: 'pre-wrap'
    },
    noteButton: {
        marginBottom: theme.spacing.unit
    },
    row: {
        paddingBottom: theme.spacing.unit,
        paddingTop: 0,
    },
    section: {
        padding: `${theme.spacing.unit}px 0`,
    },
} );

const Notes = ( { classes, notesData, addNote, defaultMessage, dataAutomationId } ) => {
    return (
        <div className={classes.section} data-automation-id={dataAutomationId}>
            <Button className={classes.noteButton} variant="outlined" onClick={addNote}>
                Add Notes
            </Button>
            {
                notesData.length > 0 ?
                    notesData.map( row => {
                        const userName = row.userName || 'Unknown';
                        const formattedDate = formatDate( row.created );

                        return (
                            <div key={row.id} className={classes.row} data-automation-id={`${dataAutomationId}-${row.id}`}>
                                <Typography color="textSecondary">{`${userName}, ${formattedDate}`}</Typography>
                                <Typography color="textPrimary" className={classes.note}>{row.note}</Typography>
                            </div>

                        );
                    } ) :
                    <Typography>{ defaultMessage }</Typography>
            }
        </div>
    );
};


Notes.propTypes = {
    addNote: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    dataAutomationId: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string,
    notesData: PropTypes.array,
};

Notes.defaultProps = {
    defaultMessage: 'No notes have been added for this domain.',
};

export default withStyles( styles )( Notes );
